import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import LeftSidebar from "../Common/LeftSidebar";
import Loader from "../Common/Loader";
import RightIconMenu from "../Common/RightIconMenu";
import RightSidebar from "../Common/RightSidebar";
import AdminDashboard from "../Dashboard/AdminDashboard";
import RecruiterDashboard from "../Dashboard/RecruiterDashboard";
import CandidateDashboard from "../Dashboard/CandidateDashboard";
import EmployerDashboard from "../Dashboard/EmployerDashboard";
import InstituteDashboard from "../Dashboard/InstituteDashboard";
import UniversityDashboard from "../Dashboard/UniversityDashboard";
import CompanyDashboard from "../Dashboard/CompanyDashboard";
import LeadDashboard from "../Dashboard/LeadDashboard";


import { username, role, roleid, user_status } from "../Actions/AuthAction";

const MainDashboard = (props) => {
  const profileCompletetionStatus = user_status();
  return (
    <React.Fragment>
      <div class="row">
        <div class="col-md-12">
          {/* <img src="assets/img/welcomeimg.png"/> */}
          <h1 className="pt-4 mb-0">Hello {username()}!</h1>
          <h6 class="subheading">Welcome to the {role()} Dashboard.</h6>
        </div>
      </div>
      {roleid() && roleid() == 1 ? (
        <AdminDashboard />
      ) : roleid() && roleid() == 2 ? (
        <InstituteDashboard />
      ) : roleid() && roleid() == 3 ? (
        <RecruiterDashboard />
      ) : roleid() && roleid() == 4 ? (
        <EmployerDashboard />
      ) : roleid() && roleid() == 5 ? (
        <CandidateDashboard
          profileCompletetionStatus={profileCompletetionStatus}
        />
      ) : roleid() && roleid() == 6 ? (
        <UniversityDashboard />
      ) : roleid() && roleid() == 7 ? (
        <CompanyDashboard />
      ) : roleid() && roleid() == 8 ? (
        <LeadDashboard />
       ) : (

        <span></span>
      )}
    </React.Fragment>
  );
};
export default MainDashboard;
